import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetExportSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetExportSettingsQuery = { __typename?: 'Query', getExportSettings?: { __typename?: 'ExportSettings', assetFolderId?: string | null, assetFolderName?: string | null, range?: Types.ExportAssetRange | null, presetId?: string | null, localCopyEnabled?: boolean | null, localFolderPath?: string | null, exportMarkersAsCommentsEnabled?: boolean | null } | null };


export const GetExportSettings = /*#__PURE__*/ gql`
    query GetExportSettings {
  getExportSettings {
    assetFolderId
    assetFolderName
    range
    presetId
    localCopyEnabled
    localFolderPath
    exportMarkersAsCommentsEnabled
  }
}
    ` as unknown as DocumentNode<GetExportSettingsQuery, GetExportSettingsQueryVariables>;

          

          export const useGetExportSettingsQuery = (options?:QueryHookOptions<GetExportSettingsQuery, GetExportSettingsQueryVariables>) => useQuery(GetExportSettings, options);

          

          export type GetExportSettingsQueryOptions = QueryHookOptions<GetExportSettingsQuery, GetExportSettingsQueryVariables>;

          

          export const useGetExportSettingsLazyQuery = (options?:LazyQueryHookOptions<GetExportSettingsQuery, GetExportSettingsQueryVariables>) => useLazyQuery(GetExportSettings, options);

          

          export type GetExportSettingsQueryResult = ReturnType<typeof useGetExportSettingsQuery>;

          
